var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplitTestBudgetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14529_62570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 8.5V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2H15.5C15.2348 2 14.9804 2.10536 14.7929 2.29289C14.6054 2.48043 14.5 2.73478 14.5 3C14.5 3.26522 14.6054 3.51957 14.7929 3.70711C14.9804 3.89464 15.2348 4 15.5 4H18.6L11.6 11H3C2.73478 11 2.48043 11.1054 2.29289 11.2929C2.10536 11.4804 2 11.7348 2 12C2 12.2652 2.10536 12.5196 2.29289 12.7071C2.48043 12.8946 2.73478 13 3 13H11.6L18.6 20H15.5C15.2348 20 14.9804 20.1054 14.7929 20.2929C14.6054 20.4804 14.5 20.7348 14.5 21C14.5 21.2652 14.6054 21.5196 14.7929 21.7071C14.9804 21.8946 15.2348 22 15.5 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V15.5C22 15.2348 21.8946 14.9804 21.7071 14.7929C21.5196 14.6054 21.2652 14.5 21 14.5C20.7348 14.5 20.4804 14.6054 20.2929 14.7929C20.1054 14.9804 20 15.2348 20 15.5V18.6L13.4 12L20 5.4V8.5C20 8.76522 20.1054 9.01957 20.2929 9.20711C20.4804 9.39464 20.7348 9.5 21 9.5C21.2652 9.5 21.5196 9.39464 21.7071 9.20711C21.8946 9.01957 22 8.76522 22 8.5Z",
    fill: "#F59D18"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14529_62570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitTestBudgetIcon);
export default __webpack_public_path__ + "static/media/splitTestBudgetIcon.7e4301c81923cd28844a43eb3e0c11e1.svg";
export { ForwardRef as ReactComponent };